import currency from "@/helpers/currency";

export const headers = {
  //
  execucao: [
    { text: "Grupo", value: "grupo" },
    { text: "Município", value: "municipio" },
    { text: "Solução", value: "solucao" },
    { text: "Responsável", value: "responsavel" },
    { text: "Horas Previstas", value: "horasPrevistas" },
    {
      text: "Horas com Relatórios Aprovados",
      value: "horasRelatoriosAprovados",
    },
    { text: "Horas Agendadas", value: "horasAgendadas" },
    { text: "Total de Horas", value: "totalGeralHoras" },
    { text: "Saldo Disponível", value: "saldoDisponivel" },

    { text: "%", value: "percentualExecutado" },
  ],
  execucao_por_tarefas: [
    { text: "Grupo", value: "grupo" },
    { text: "Município", value: "municipio" },
    { text: "Solução", value: "solucao" },
    { text: "Responsável", value: "responsavel" },
    { text: "Tarefas Previstas", value: "horasPrevistas" },
    { text: "Tarefas Executadas", value: "horasRealizadas" },
    { text: "%", value: "percentual" },
  ],
  relatorio_por_solucao: [
    { text: "Grupo", value: "grupo" },
    { text: "Solução", value: "solucao" },
    { text: "Município", value: "municipio" },
    { text: "Data", value: "data" },
    { text: "Responsável", value: "responsavel" },
    { text: "Relatório", value: "relatorio" },
    { text: "Tarefas", value: "tarefas" },
    { text: "Horas", value: "horas" },
    { text: "Situação", value: "situacao" },
  ],
  encontros_por_solucao: [
    { text: "Título", value: "titulo" },
    { text: "Responsável", value: "responsavel" },
    { text: "Município", value: "municipio" },
    { text: "Data", value: "data" },
    { text: "Tem Relatório", value: "relatorio" },
  ],
  situacaoVisitas: [
    { text: "Município", value: "municipio" },
    { text: "Solução", value: "solucao" },
    { text: "Responsavel", value: "responsavel" },
    { text: "Status", value: "situacao" },
    { text: "Visitas", value: "visitas" },
  ],
  situacaoTarefa: [
    { text: "Município", value: "municipio" },
    { text: "Solução", value: "solucao" },
    { text: "Responsavel", value: "responsavel" },
    { text: "Tarefa", value: "tarefa", width: "30%" },
    { text: "Data", value: "dataEvento", align: "start" },
    { text: "Status", value: "situacao" },
  ],
  diagnostico: [
    { text: "Município", value: "municipio" },
    { text: "Eixo", value: "eixo" },
  ],
  diagnosticoFinalizado: [
    { text: "Município", value: "nomeMunicipio", align: "start" },
    { text: "Eixo", value: "nome", align: "start" },
    { text: "Pontos ", value: "pontos", align: "start" },
  ],
  evidencias: [
    { text: "Município", value: "municipio", align: "start" },
    { text: "Eixo", value: "eixo" },
    { text: "Questões não evidenciadas", value: "semEvidencias" },
  ],
  rejeicao: [
    { text: "Município", value: "municipio" },
    { text: "Eixo", value: "eixo" },
    { text: "Perguntas", value: "perguntas" },
    { text: "Respondidas", value: "respondidas" },
    { text: "Evidenciadas", value: "evidenciadas" },
    { text: "Aprovadas", value: "aprovadas" },
    { text: "Rejeitadas", value: "rejeitadas" },
    { text: "Aguardando Análise", value: "aguardandoAnalise" },
  ],
  execucao_hora: [
    { text: "Município", value: "municipio" },
    { text: "Horas Previstas", value: "horasPrevistas" },
    { text: "Horas Realizadas", value: "horasRealizadas" },
    { text: "Percentual", value: "percentual" },
    { text: "Responsável", value: "responsavel" },
    { text: "Solução", value: "solucao" },
  ],
  situacao_medalha: [
    { text: "Município", value: "nome" },
    { text: "Tema", value: "nomeTema" },
    { text: "Medalha Bronze", value: "possuiBronze" },
    { text: "Medalha Prata", value: "possuiPrata" },
    { text: "Medalha Ouro", value: "possuiOuro" },
  ],
  situacao_medalha_pontos_tema: [
    { text: "Município", value: "nome" },
    { text: "Região", value: "nomeRegiao" },

    { text: "Tema", value: "nomeTema" },
    { text: "Pontos", value: "pontos" },
    { text: "Pontos de acompanhamento", value: "acompanhamentosPontos" },

    { text: "Medalha Bronze", value: "bronze" },
    { text: "Medalha Prata", value: "prata" },
    { text: "Medalha Ouro", value: "ouro" },
  ],
  execucao_tarefas_inicio_fim: [
    { text: "Município", value: "municipio" },

    { text: "Início", value: "inicio" },
    { text: "Fim", value: "fim" },
    { text: "Projeto", value: "projeto" },
    { text: "Percentual", value: "percentual" },
    { text: "Solução", value: "solucao" },
    { text: "Tarefas Previstas", value: "tarefasPrevistas" },
    { text: "Tarefas Realizadas", value: "tarefasRealizadas" },
  ],
  eixo_municipio_desagrupado: [
    { text: "Município", value: "municipio" },
    { text: "Uf", value: "uf" },
    { text: "Codigo IBGE", value: "codigoIbge" },
    { text: "Relacionamento", value: "relacionamento" },
    { text: "Contrato", value: "contrato" },
    { text: "Subsídio", value: "subsidio" },
    { text: "Início Contrato", value: "inicioContrato" },
    { text: "Término Contrato", value: "terminoContrato" },
    { text: "Eixo", value: "eixo" },
  ],
  eixo_municipio: [
    { text: "Município", value: "municipio" },
    { text: "Uf", value: "uf" },
    { text: "Codigo IBGE", value: "codigoIbge" },
    { text: "Relacionamento", value: "relacionamento" },
    { text: "Contrato", value: "contrato" },
    { text: "Subsídio", value: "subsidio" },
    { text: "Início Contrato", value: "inicioContrato" },
    { text: "Término Contrato", value: "terminoContrato" },
    { text: "Eixo", value: "subsidio" },
  ],
  relacao_solucao_tarefa_cadastrada_uf: [
    { text: "Grupo de Solução", value: "municipio" },
    { text: "Solução", value: "uf" },
    { text: "Descrição da Solução", value: "codigoIBGE" },
    { text: "Tarefa", value: "relacionamento" },
    { text: "Descrição da Tarefa", value: "relacionamento" },
    { text: "Evidência", value: "relacionamento" },
  ],
  plano_acao_analitico: [
    { text: "Unidade Regional", value: "nomeRegiao" },
    { text: "Município", value: "nomeMunicipio" },
    { text: "Temas", value: "nomeTema" },
    { text: "Pergunta", value: "numero" },
    { text: "Pontos", value: "pontos" },
    { text: "Indicador", value: "indicador" },
    { text: "Resposta", value: "resposta" },
    { text: "Evidencia", value: "evidencia" },
  ],
  analitico_indicadores: [
    { text: "Unidade Regional", value: "nomeRegiao" },
    { text: "Município", value: "nomeMunicipio" },
    { text: "Temas", value: "nomeTema" },
    { text: "Pergunta", value: "numero" },
    { text: "Pontos", value: "pontos" },
    { text: "Indicador", value: "indicador" },
    { text: "Resposta", value: "resposta" },
    { text: "Data Resposta", value: "dataResposta" },
  ],
  consolidado_indicadores_sim: [
    { text: "Unidade Regional", value: "nomeMunicipio" },
    { text: "Município", value: "nomeRegiao" },
    { text: "Temas", value: "nomeTema" },
    { text: "Quantidade de Indicadores", value: "quantidadeIndicadores" },
    { text: "Respostas SIM", value: "respostaSim" },
  ],
  indicadores_ativos: [
    { text: "Temas", value: "nome" },
    { text: "Pergunta", value: "numero" },
    { text: "Pontos", value: "pontos" },
    { text: "Nacional", value: "nacional" },
    { text: "Indicador", value: "texto" },
    { text: "Evidencia", value: "evidencia" },
  ],
  to_pendentes: [
    { text: "Uf", value: "uf" },
    { text: "Codigo IBGE", value: "codigoIBGE" },
    { text: "Município", value: "nomeMunicipio" },
    { text: "Tema", value: "nomeTema" },
    { text: "Unidade Regional", value: "nomeRegiao" },
    { text: "T0", value: "nomeregiao" },
  ],
  municipio_quantidade_mensuracoes: [
    { text: "Unidade Regional", value: "unidadeRegional" },
    { text: "Projeto", value: "projeto" },
    { text: "Município", value: "municipio" },
    { text: "Eixo", value: "eixo" },
    { text: "Mensurações", value: "mensuracoes" },
  ],
  municipio_quantidade_mensuracoes_regional_municipio: [
    { text: "Unidade Regional", value: "nomeRegiao" },
    { text: "Município", value: "municipio" },
    { text: "Eixo", value: "eixos" },
    { text: "Mensurações", value: "mensuracoes" },
  ],
  municipio_eixo_status_relacionamento: [
    { text: "Uf", value: "uf" },
    { text: "Codigo IBGE", value: "codigoIbge" },
    { text: "Município", value: "nome" },
    { text: "Status", value: "statusNome" },
    { text: "Eixo", value: "eixoNome" },
  ],
  evidencia_rejeitada_por_municipio: [
    { text: "Nome Região", value: "nomeRegiao", width: "5%" },
    { text: "Município", value: "municipio", width: "10%" },
    { text: "Resposta", value: "resposta", width: "10%" },
    { text: "Situacao da evidência", value: "situacaoEvidencia", width: "10%" },
    { text: "Justificativa", value: "justificativa", width: "15%" },
    { text: "Arquivo", value: "link", width: "5%" },
    { text: "Arquivos Inseridos", value: "arquivosInseridos", width: "10px" },
    { text: "Tema", value: "tema", width: "10%" },
    { text: "N° Pergunta", value: "numero", width: "10%" },
    { text: "Indicador", value: "indicador", width: "10%" },
    { text: "Pontos", value: "pontos", width: "5%" },
  ],
  relacao_diagnosticos: [
    { text: "Unidade Regional", value: "unidadeRegional", width: "5%" },
    { text: "Município", value: "municipio", width: "10%" },
    { text: "Usuário", value: "usuario", width: "10%" },
    {
      text: "Diagnóstico / Acompanhamento",
      value: "diagnosticoAcompamhamento",
      width: "10%",
    },
    { text: "Data", value: "data", width: "15%" },
    {
      text: "Indicadores Positivados",
      value: "indicadoresPositivados",
      width: "15%",
    },
  ],
  parceiro_selos_atribuidos: [
    { text: "Nome", value: "nome" },
    { text: "Selo", value: "selo" },
  ],
  quantidade_selos_atribuidos: [
    { text: "Ouro", value: "ouro" },
    { text: "Prata", value: "prata" },
    { text: "Bronze", value: "bronze" },
  ],
  diagnosticos_consolidados_situacao: [
    { text: "UF", value: "uf", align: "start" },
    { text: "Não Iniciado", value: "naoIniciado" },
    { text: "Em Preenchimento", value: "emPreenchimento" },
    { text: "Enviado", value: "enviado" },
  ],
  diagnosticos_detalhados: [
    { text: "UF", value: "uf", align: "start" },
    { text: "Unidade Regional", value: "nomeRegiao" },
    { text: "Sala", value: "nome" },
    { text: "Situação", value: "situacao" },
  ],
  diagnosticos_admin_periodo: [
    { text: "Consultor", value: "usuarioNome", align: "start" },
    { text: "Município", value: "municipioNome" },
    { text: "Início", value: "inicio" },
    { text: "Fim", value: "fim" },
    { text: "Horas", value: "horas" },
    { text: "Status", value: "status" },
  ],
  situacao_detalhada_envio_evidencia: [
    { text: "Regional", value: "nomeRegiao", align: "start" },
    { text: "Sala", value: "municipioNome", align: "start" },
    { text: "Pilar", value: "nomeTema", align: "start" },
    { text: "Critério", value: "texto", align: "start" },
    {
      text: "Arquivos não Enviados",
      value: "naoEnviadosAnalise",
      align: "start",
    },
    {
      text: "Arquivos Enviados",
      value: "arquivosEnviadosAnalise",
      align: "start",
    },
    { text: "Arquivos em Análise", value: "arquivosEmAnalise", align: "start" },
    { text: "Arquivos Aprovados", value: "arquivosAprovados", align: "start" },
    {
      text: "Arquivos Rejeitados",
      value: "arquivosRejeitados",
      align: "start",
    },
    { text: "Pontos Possíveis", value: "pontosPossiveis", align: "start" },
    { text: "Pontos Obtidos", value: "pontosObtidos", align: "start" },
  ],
  analitico_pontos_eixos: [
    { text: "Eixo", value: "eixo", align: "start" },
    { text: "Município", value: "municipio", align: "start" },
    { text: "Pontos", value: "pontos", align: "start" },
    { text: "Projeto", value: "projeto", align: "start" },
    { text: "UF", value: "uf", align: "start" },
    { text: "Usuário", value: "usuario", align: "start" },
  ],
  quantitativo_municipio_sem_atuacao_regiao: [
    { text: "Regional", value: "regional", align: "start" },
    { text: "Com atuação", value: "comAtuacao", align: "start" },
    { text: "Sem atuação", value: "semAtuacao", align: "start" },
  ],
  encontros_realizados_status: [
    { text: "Regional", value: "regional", align: "start" },
    { text: "Município", value: "nome", align: "start" },
    { text: "Com Relatório", value: "comRelatorio", align: "start" },
    { text: "Sem Relatório", value: "semRelatorio", align: "start" },
  ],
  municipios_status_atuacao_responsavel: [
    { text: "Regional", value: "regional", align: "start" },
    { text: "Município", value: "municipio", align: "start" },
    { text: "Atuação", value: "atuacao", align: "start" },
    { text: "Responsável", value: "responsavel", align: "start" },
  ],
  cliente_oculto_analitico_situacao: [
    { text: "Uf", value: "uf", align: "start" },
    { text: "Código Ibge", value: "codigoIbge", align: "start" },
    { text: "Município", value: "nome", align: "start" },
    { text: "Status", value: "status", align: "start" },
    { text: "Arquivos Enviados", value: "arquivosEnviados", align: "start" },
  ],
  execucao_cliente_oculto: [
    { text: "Grupo", value: "gruponome", align: "start" },
    { text: "Quantidade", value: "qtd", align: "start" },
  ],
  mensuracao_detalhada_por_periodo: [
    { text: "Município", value: "municipio", align: "start" },
    { text: "Acompanhamento", value: "nome", align: "start" },
    { text: "Responsável", value: "responsavel", align: "start" },
    { text: "Data de Finalização", value: "dataFinalizacao", align: "start" },
    { text: "Eixo", value: "eixo", align: "start" },
    { text: "Indicador", value: "indicador", align: "start" },
    { text: "Resposta", value: "resposta", align: "start" },
  ],
  situacao_solucoes_municipios: [
    { text: "Município", value: "municipio", align: "start" },
    { text: "Grupo", value: "grupo", align: "start" },
    { text: "Solução", value: "solucao", align: "start" },
    { text: "Situação da Solução", value: "situacaoSolucao", align: "start" },
    { text: "Tarefa", value: "tarefa", align: "start" },
    { text: "Horas", value: "horas", align: "start" },
    { text: "Situação da Tarefa", value: "situacaoTarefa", align: "start" },
    { text: "Evidência", value: "evidencia", align: "start" },
  ],
  prateleira_de_solucoes: [
    { text: "Grupo", value: "grupo", align: "start" },
    { text: "Solução", value: "solucao", align: "start" },
    { text: "Tarefa", value: "tarefa", align: "start" },
    { text: "Horas", value: "horas", align: "start" },
  ],

  territorios_iniciativas: [
    { text: "UF", value: "uf", align: "start" },
    { text: "Território", value: "nomeTerritorio", align: "start" },
    { text: "Link", value: "link", align: "start" },
    { text: "Nome Fantasia", value: "nomeFantasia", align: "start" },
    { text: "Inicio", value: "inicio", align: "start" },
    { text: "Status", value: "statusTerritorio", align: "start" },
    { text: "Iniciativa", value: "iniciativa", align: "start" },
    {
      text: "Categoria da Iniciativa",
      value: "categoriaIniciativa",
      align: "start",
    },
    {
      text: "Descrição da Iniciativa",
      value: "descricaoIniciativa",
      align: "start",
    },
    { text: "Iniciativa Própria", value: "iniciativaPropria", align: "start" },
    { text: "Todos os municípios", value: "emTodosMunicipios", align: "start" },
    { text: "Exceção", value: "excecao", align: "start" },
    { text: "Início da iniciativa", value: "inicioIniciativa", align: "start" },
    { text: "Fim da iniciativa", value: "fimIniciativa", align: "start" },
    { text: "Status da iniciativa", value: "statusIniciativa", align: "start" },
    { text: "Custo da iniciativa", value: "custo", align: "start" },
    {
      text: "Responsáveis da iniciativa",
      value: "responsaveis",
      align: "start",
    },
    { text: "Atores da iniciativa", value: "atores", align: "start" },
  ],
  territorios_municipios: [
    { text: "UF", value: "uf", align: "start" },
    { text: "Código IBGE", value: "codigoIbge", align: "start" },
    { text: "Município", value: "municipio", align: "start" },
    { text: "Território", value: "nomeTerritorio", align: "start" },
    { text: "Nome Fantasia", value: "nomeFantasia", align: "start" },
    { text: "Inicio", value: "inicio", align: "start" },
    { text: "Status", value: "statusTerritorio", align: "start" },
    { text: "Responsáveis", value: "responsaveis", align: "start" },
    { text: "Categorias", value: "categorias", align: "start" },
    { text: "Iniciativas", value: "iniciativas", align: "start" },
  ],
  selo: [
    { text: "UF", value: "uf", align: "start" },
    { text: "Município", value: "municipioNome", align: "start" },
    { text: "Selo", value: "selo", align: "start" },
    { text: "Unidade Regional", value: "nomeRegiao", align: "start" },
  ],
  detalhamento_propostas: [
    { text: "Município", value: "nome", align: "start" },
    { text: "Status", value: "status", align: "start" },
    {
      text: "Valor Total",
      value: "valorTotal",
      align: "start",
    },
    {
      text: "Investimento Município",
      value: "investimentoMunicipio",
      align: "start",
    },
    { text: "Parcelas", value: "qtParcelas", align: "start" },
    { text: "Criação", value: "criacao", align: "start" },

    { text: "Data Criação", value: "dataCriacao", align: "start" },
    { text: "Análise", value: "analise", align: "start" },

    { text: "Data Análise", value: "dataAnalise", align: "start" },
    {
      text: "Autorização de Execução'",
      value: "autorizacaoExecucao",
      align: "start",
    },

    {
      text: "Data de início da execução",
      value: "dataInicioExecucao",
      align: "start",
    },
    { text: "Representantes", value: "representantes", align: "start" },
  ],
};
